import { API } from 'aws-amplify'
import { gql } from 'graphql-tag'

const searchTags = async ({
  from,
  size = 10,
  query,
  types = ['coverageArea', 'featureType', 'topic']
}) => {
  const response = await API.graphql({
    query: searchTagQuery,
    variables: {
      from,
      size,
      query,
      types
    },
    authMode: 'API_KEY'
  })
  return response.data
}

const searchTagQuery = gql`
  query SearchTags(
    $from: Int
    $size: Int
    $query: String
    $types: [TAG_TYPES!]
  ) {
    searchTags(from: $from, size: $size, query: $query, types: $types) {
      id
      name
      count
      description
      type
    }
  }
`
export { searchTags, searchTagQuery }
